import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useProfile } from "../../../contexts/ProfileContext.tsx";

function RenderBodyNomeTabelaDesordenada({
	nomeTable,
	row,
	linhaSelecionada,
	getMotionProps,
	setDadosRastrearRedux,
	showDropDowEmbarques,
	configDataHora,
	setColunaSelecionada,
	setOpenRegras,
	rowIndex,
	classeSelecionado,
	configEntrega
}) {
	const { tabelaUsuario, contextoEmbarque } = useProfile();
	const navigate = useNavigate();

	return (
		<>
			{tabelaUsuario[nomeTable]?.map((col, index) => {
				if (col.visivel === "true" || col.visivel === true) {
					if (col.field === "motorista") {
						if (row.coordenadasRastreioMotorista !== null) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`motorista-${row.motorista} ${row.idEmbarque}`}
									className="rastreio"
									onClick={(e) => {
										if (row.coordenadasRastreioMotorista != null) {
											setDadosRastrearRedux((current) => ({
												...current,
												endereco: row.coordenadasRastreioMotorista,
												idEmbarque: row.idEmbarque,
											}));
											navigate("/rastrear");
										}
									}}
								>
									{row.motorista}
								</motion.td>
							);
						} else {
							<motion.td
								{...getMotionProps(index)}
								key={`motorista-${row.motorista} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.motorista}
							</motion.td>;
						}
					}
					if (col.field === "veiculoMotorista") {
						if (row.veiculoMotorista) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`veiculoMotorista.nome-${row.veiculoMotorista.nome} ${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								>
									{row.veiculoMotorista.nome}
								</motion.td>
							);
						}
					}
					if (col.field === "proprietario") {
						return (
							<motion.td
								key={`proprietario-${row.proprietario} ${uuidv4()}`}
								{...getMotionProps(index)}
								style={{ color: row.corCliente }}
							>
								{row.proprietario}
							</motion.td>
						);
					}
					if (col.field === "nEntregas") {
						if (row.nEntregas) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`nEntregasFeitas${row.nEntregasFeitas} ${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								>
									{row.nEntregasFeitas}/{row.nEntregas}
								</motion.td>
							);
						}
					}
					if (col.field === "usuarioResponsavel") {
						if (row.usuarioResponsavel) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`usuarioResponsavel-${row.usuarioResponsavel.usuario} ${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								>
									{row.usuarioResponsavel.usuario}
								</motion.td>
							);
						}
					}
					if (col.field === "cte") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`cte-${row.cte} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.cte}
							</motion.td>
						);
					}
					if (col.field === "load") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`load-${row.load} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.load}
							</motion.td>
						);
					}
					if (col.field === "km") {
						const kmValue = Math.trunc(parseFloat(row.km));
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`kmvalue-${kmValue} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="td-right"
							>
								{isNaN(kmValue) ? 0 : kmValue}
							</motion.td>
						);
					}
					if (
						col.field === "embarcador" ||
						col.field === "cliente" ||
						col.field === "destinatario" ||
						col.field === "pedido"
					) {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`embarcador-cliente-${row[col.field]}-${row.idEmbarque
									}-${index}`}
							>
								{row[col.field]}
							</motion.td>
						);
					}
					if (col.field === "placaCavalo") {
						if (row.caminhao !== null) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`placaCavalo-${row.placaCavalo} ${row.idEmbarque}`}
									className="rastreio"
									onClick={(e) => {
										if (row.caminhao !== null) {
											setDadosRastrearRedux((current) => ({
												...current,
												idVeiculo: row.caminhao.idCaminhao,
												tipoVeiculo: 1,
											}));
											navigate("/rastrear");
										}
									}}
								>
									{row.placaCavalo}
								</motion.td>
							);
						} else {
							if (row.temApiSul === true) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`placaCavaloApiSul-${row.placaCavalo} ${row.idEmbarque}`}
										className="td-left-veiculo"
										style={{
											color: row.corCliente,
										}}
									>
										{row.placaCavalo}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`placaCavaloSemApiSul-${row.placaCavalo} ${row.idEmbarque}`}
										style={{
											color: row.corCliente,
										}}
									>
										{row.placaCavalo}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "placaCarreta") {
						if (row.carreta !== null) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`placaCarreta-${row.placaCarreta} ${row.idEmbarque}`}
									className="rastreio"
									onClick={(e) => {
										if (row.carreta !== null) {
											setDadosRastrearRedux((current) => ({
												...current,
												idVeiculo: row.carreta.idCarreta,
												tipoVeiculo: 2,
											}));
											navigate("/rastrear");
										}
									}}
								>
									{row.placaCarreta}
								</motion.td>
							);
						} else {
							<motion.td
								{...getMotionProps(index)}
								key={`placaCarretaNull-${row.placaCarreta} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.placaCarreta}
							</motion.td>;
						}
					}
					if (col.field === "placaCarreta2") {
						if (row.carreta2 !== null) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`placaCarreta2-${row.placaCarreta2} ${row.idEmbarque}`}
									className="rastreio"
									onClick={(e) => {
										if (row.carreta2 !== null) {
											setDadosRastrearRedux((current) => ({
												...current,
												idVeiculo: row.carreta2.idCarreta,
												tipoVeiculo: 2,
											}));
											navigate("/rastrear");
										}
									}}
								>
									{row.placaCarreta2}
								</motion.td>
							);
						} else {
							<motion.td
								{...getMotionProps(index)}
								key={`placaCarreta2Null-${row.placaCarreta2} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.placaCarreta2}
							</motion.td>;
						}
					}
					if (col.field === "descricao") {
						if (contextoEmbarque === "templateEmbarque") {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`descricao-${row.descricao} ${row.idEmbarque}-${rowIndex}-${index}`}
									style={{ color: row.corCliente }}
								>
									{row.descricao}
								</motion.td>
							);
						} else {
							return (
								<Fragment
									key={`descricao-${row.idEmbarque}-${rowIndex}-${index}`}
								/>
							);
						}
					}
					if (col.field === "margem" || col.field === "pedido") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`margem-pedido-${row[col.field]} ${row.idEmbarque
									}-${index}`}
								className="td-right"
								style={{ color: row.corCliente }}
							>
								{row[col.field]}
							</motion.td>
						);
					}
					if (col.field === "adiantamento") {
						if (row.adiantamento !== null) {
							const adtSplit = row.adiantamento.split(",");
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`adiantamento-${row.adiantamento} ${row.idEmbarque}`}
									className="td-right"
								>
									{adtSplit[0]}
								</motion.td>
							);
						}
					}
					if (col.field === "saldo") {
						if (row.saldo !== null) {
							const adtSplit = row.saldo.split(",");
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`saldo-${row.saldo} ${row.idEmbarque}`}
									className="td-right"
								>
									{adtSplit[0]}
								</motion.td>
							);
						}
					}
					if (col.field === "freteFiscal" || col.field === "freteMotorista") {
						if (row.freteFiscal !== null) {
							let value;
							if (typeof row[col.field] === "string") {
								value = row[col.field].replace(",", ".");
							}
							if (
								typeof value === "string" &&
								(value.match(/\./g) || []).length > 1
							) {
								value = value.replace(".", "");
							}
							if (row.valorVariavelAlto) {
								if (isNaN(parseFloat(value))) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`freteFiscal-${row[col.field]} ${row.idEmbarque}`}
											style={{
												color: row.corCliente,
											}}
											className="td-center-frete-fiscal"
										>
											{row[col.field]}
										</motion.td>
									);
								} else {
									let floatValue = parseFloat(value);
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`floatvalue-${row[col.field]} ${row.idEmbarque}`}
											style={{
												color: row.corCliente,
											}}
											className="td-center-frete-fiscal"
										>
											{floatValue.toLocaleString("pt-BR", {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</motion.td>
									);
								}
							} else {
								if (isNaN(parseFloat(value))) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`value-${row[col.field]} ${row.idEmbarque}-${index}`}
											style={{
												color: row.corCliente,
											}}
											className="td-right"
										>
											{row[col.field]}
										</motion.td>
									);
								} else {
									let floatValue = parseFloat(value);
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`value-${row[col.field]} ${row.idEmbarque}-${index}`}
											style={{
												color: row.corCliente,
											}}
											className="td-right"
										>
											{floatValue.toLocaleString("pt-BR", {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										</motion.td>
									);
								}
							}
						}
					}
					if (col.objetoUnidadeEmbarque === "true") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`cidadeEstado-${row[col.field]} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
							>
								{row.cidadeEstado.cidade}
							</motion.td>
						);
					}
					if (col.field === "unidEmbarque") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`unidEmbarque-${row.unidEmbarque} ${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="v-entrega"
							>
								{row.entrega && row.entrega.length ? (
									<>
										{linhaSelecionada.includes(row.idEmbarque) ? (
											<KeyboardArrowUpIcon
												className="icon-entrega"
												onClick={() => {
													showDropDowEmbarques(row);
												}}
											/>
										) : (
											<KeyboardArrowDownIcon
												className="icon-entrega"
												onClick={() => {
													showDropDowEmbarques(row);
												}}
											/>
										)}

										<span>{row[col.field]}</span>
									</>
								) : (
									<span>{row[col.field]}</span>
								)}
							</motion.td>
						);
					}
					if (col.field === "embarcadorEstado") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`embarcadorEstado-${row.embarcadorEstado}-${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.embarcadorEstado}
							</motion.td>
						);
					}
					if (col.field === "unidEmbarque") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`${row.unidEmbarque}-${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.unidEmbarque}
							</motion.td>
						);
					}
					if (col.field === "estadoOrigem") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`estadoOrigem-${row.estadoOrigem}-${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.estadoOrigem}
							</motion.td>
						);
					}
					if (col.field === "estadoDestino") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`estadoDestino-${row.estadoDestino}-${row.idEmbarque}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.estadoDestino}
							</motion.td>
						);
					}
					if (col.field === "rota") {
						if (row.abaixoPisoAntt === true) {
							if (row.freteMinimoMotorista) {
								return (
									<Tooltip
										key={`freteMinimo-${row.freteMinimoMotorista}-${row.idEmbarque}`}
										title={
											<p>
												{`Abaixo do valor mínimo de frete: ${row.freteMinimoMotorista.toLocaleString(
													"pt-BR",
													{
														style: "currency",
														currency: "BRL",
													}
												)}`}
												<br />
												{`Quantidade excedida de piso: ${row?.quantidadeExcedidaPiso?.toLocaleString(
													"pt-BR",
													{
														style: "currency",
														currency: "BRL",
													}
												)}`}
											</p>
										}
									>
										<motion.td
											{...getMotionProps(index)}
											className="data-piscando-1"
											style={{
												color: row.corCliente,
												cursor: "pointer",
											}}
										>
											{row.rota}
										</motion.td>
									</Tooltip>
								);
							}
						} else {
							if (row.freteMinimoMotorista) {
								return (
									<Tooltip
										key={`freteMinimo-${row.freteMinimoMotorista}-${row.idEmbarque}`}
										title={
											<p>
												{row.freteMinimoMotorista.toLocaleString("pt-BR", {
													style: "currency",
													currency: "BRL",
												})}
												<br />
												{`Quantidade excedida de piso: ${row?.quantidadeExcedidaPiso?.toLocaleString(
													"pt-BR",
													{
														style: "currency",
														currency: "BRL",
													}
												)}`}
											</p>
										}
									>
										<motion.td
											{...getMotionProps(index)}
											style={{
												color: row.corCliente,
												cursor: "pointer",
											}}
										>
											{row.rota}
										</motion.td>
									</Tooltip>
								);
							}
						}
					}
					if (col.field === "previsaoEmbarque") {
						if (
							row.previsaoEmbarque === "2000-01-01T00:00:00" ||
							row.previsaoEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (row.tempoFaltanteEmbarque !== null) {
								if (row.tempoFaltanteEmbarque === 1) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-1"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-1"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEmbarque === 2) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-2"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-2"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEmbarque === 3) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-3"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-3"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEmbarque === 4) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-4"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
												className="data-piscando-4"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEmbarque).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								}
							} else {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.previsaoEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`previsaoEmbarque-${row.previsaoEmbarque}-${row.idEmbarque}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.previsaoEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							}
						}
					}
					if (col.field === "dataEmbarque") {
						if (row.dataEmbarque === "2000-01-01T00:00:00") {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataEmbarque-${row.dataEmbarque}-${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (configDataHora) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEmbarque-${row.dataEmbarque}-${row.idEmbarque}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEmbarque).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										})}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEmbarque-${row.dataEmbarque}-${row.idEmbarque}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEmbarque).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
										})}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "aceite") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`aceite ${row.aceite}`}
								style={{ color: row.corCliente }}
								className="td-center"
								onClick={() => {
									setColunaSelecionada &&
										setColunaSelecionada(row[classeSelecionado]);
									setOpenRegras && setOpenRegras(true);
								}}
							>
								{row.aceite}
							</motion.td>
						);
					}
					if (col.field === "destinatarioEstado") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`destinatarioEstado ${row.destinatarioEstado}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.destinatarioEstado}
							</motion.td>
						);
					}
					if (col.field === "dataHoraChegadaEmbarque") {
						if (
							row.dataHoraChegadaEmbarque === "2000-01-01T00:00:00" ||
							row.dataHoraChegadaEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataHoraChegadaEmbarque ${row.dataHoraChegadaEmbarque}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (row.onTimeEmbarque) {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEmbarque ${row.dataHoraChegadaEmbarque}`}
											className="data-piscando-1"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEmbarque ${row.dataHoraChegadaEmbarque}`}
											className="data-piscando-1"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							} else {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEmbarque ${row.dataHoraChegadaEmbarque}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEmbarque ${row.dataHoraChegadaEmbarque}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEmbarque).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							}
						}
					}
					if (col.field === "dataHoraChegadaEntrega") {
						if (
							row.dataHoraChegadaEntrega === "2000-01-01T00:00:00" ||
							row.dataHoraChegadaEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (row.onTimeEntrega) {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											className="data-piscando-1"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											className="data-piscando-1"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							} else if (row.excedeuDiariaCliente) {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											className="data-piscando-5"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											className="data-piscando-5"
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							} else {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`dataHoraChegadaEntrega ${row.dataHoraChegadaEntrega}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							}
						}
					}
					if (col.field === "dataHoraEntregue") {
						if (
							row.dataHoraEntregue === "2000-01-01T00:00:00" ||
							row.dataHoraEntregue === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataHoraEntregue ${row.dataHoraEntregue}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (configDataHora) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataHoraEntregue ${row.dataHoraEntregue}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataHoraEntregue).toLocaleDateString(
											"pt-BR",
											{
												month: "numeric",
												day: "numeric",
												hour: "numeric",
												minute: "numeric",
											}
										)}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataHoraEntregue ${row.dataHoraEntregue}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataHoraEntregue).toLocaleDateString(
											"pt-BR",
											{
												month: "numeric",
												day: "numeric",
											}
										)}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "dataHoraEmbarcado") {
						if (
							row.dataHoraEmbarcado === "2000-01-01T00:00:00" ||
							row.dataHoraEmbarcado === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataHoraEmbarcado ${row.dataHoraEmbarcado}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (configDataHora) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataHoraEmbarcado ${row.dataHoraEmbarcado}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataHoraEmbarcado).toLocaleDateString(
											"pt-BR",
											{
												month: "numeric",
												day: "numeric",
												hour: "numeric",
												minute: "numeric",
											}
										)}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataHoraEmbarcado ${row.dataHoraEmbarcado}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataHoraEmbarcado).toLocaleDateString(
											"pt-BR",
											{
												month: "numeric",
												day: "numeric",
											}
										)}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "frota") {
						if (row.frota === "Sim") {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`frota ${row.frota}`}
									style={{ color: row.corCliente }}
								>
									Sim
								</motion.td>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`frota ${row.frota}`}
									style={{ color: row.corCliente }}
								>
									Não
								</motion.td>
							);
						}
					}
					if (col.field === "notificarACadaData") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`notificarACadaData ${row.notificarACadaData}`}
								style={{ color: row.corCliente }}
							>
								{row.notificarACadaData}
							</motion.td>
						);
					}
					if (col.field === "tipoCheck") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`tipoCheck ${row.tipoCheck.nome}`}
								style={{ color: row.corCliente }}
							>
								{row.tipoCheck.nome}
							</motion.td>
						);
					}
					if (col.field === "dataCheckagem") {
						return (
							<motion.td
								{...getMotionProps(index)}
								key={`dataCheckagem ${row.dataCheckagem}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{new Date(row.dataCheckagem).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "proximaRevisaoData") {
						if (row.proximaRevisaoData === null) {
							<motion.td
								{...getMotionProps(index)}
								key={`proximaRevisaoData ${row.proximaRevisaoData}`}
								style={{ color: row.corCliente }}
							/>;
						} else {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`proximaRevisaoData ${row.proximaRevisaoData}`}
									style={{ color: row.corCliente }}
									className="td-center"
								>
									{new Date(row.proximaRevisaoData).toLocaleDateString(
										"pt-BR",
										{
											year: "numeric",
											month: "numeric",
											day: "numeric",
										}
									)}
								</motion.td>
							);
						}
					}
					if (
						col.field === "notificarAutomatico" ||
						col.field === "cancelado" ||
						col.field === "comprovante" ||
						col.field === "checkInFeito"
					) {
						if (row[col.field] === true) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`${col.field} ${row[col.field]}`}
									style={{ color: row.corCliente }}
								>
									Sim
								</motion.td>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`${col.field} ${row[col.field]}`}
									style={{ color: row.corCliente }}
								>
									Não
								</motion.td>
							);
						}
					}
					if (col.field === "previsaoEntrega") {
						if (
							row.previsaoEntrega === "2000-01-01T00:00:00" ||
							row.previsaoEntrega === null
						) {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`previsaoEntrega ${row.previsaoEntrega}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (row.tempoFaltanteEntrega !== null) {
								if (row.tempoFaltanteEntrega === 1) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-1"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-1"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEntrega === 2) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-2"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-2"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEntrega === 3) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-3"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-3"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								} else if (row.tempoFaltanteEntrega === 4) {
									if (configDataHora) {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-4"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
														hour: "numeric",
														minute: "numeric",
													}
												)}
											</motion.td>
										);
									} else {
										return (
											<motion.td
												{...getMotionProps(index)}
												transition={{
													duration: 0.2,
												}}
												key={`previsaoEntrega ${row.previsaoEntrega}`}
												className="data-piscando-4"
												style={{
													color: row.corCliente,
												}}
											>
												{new Date(row.previsaoEntrega).toLocaleDateString(
													"pt-BR",
													{
														month: "numeric",
														day: "numeric",
													}
												)}
											</motion.td>
										);
									}
								}
							} else {
								if (configDataHora) {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`previsaoEntrega ${row.previsaoEntrega}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.previsaoEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
													hour: "numeric",
													minute: "numeric",
												}
											)}
										</motion.td>
									);
								} else {
									return (
										<motion.td
											{...getMotionProps(index)}
											key={`previsaoEntrega ${row.previsaoEntrega}`}
											style={{
												color: row.corCliente,
											}}
										>
											{new Date(row.previsaoEntrega).toLocaleDateString(
												"pt-BR",
												{
													month: "numeric",
													day: "numeric",
												}
											)}
										</motion.td>
									);
								}
							}
						}
					}
					if (col.field === "dataEntrega") {
						if (row.dataEntrega === "2000-01-01T00:00:00") {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataEntrega ${row.dataEntrega}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (configDataHora) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEntrega ${row.dataEntrega}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEntrega).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										})}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEntrega ${row.dataEntrega}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEntrega).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
										})}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "dataEmbarque") {
						if (row.dataEmbarque === "2000-01-01T00:00:00") {
							return (
								<motion.td
									{...getMotionProps(index)}
									key={`dataEmbarque ${row.dataEmbarque}-${row.idEmbarque}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							if (configDataHora) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEmbarque ${row.dataEmbarque}-${row.idEmbarque}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEmbarque).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										})}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`dataEmbarque ${row.dataEmbarque}-${row.idEmbarque}`}
										style={{
											color: row.corCliente,
										}}
									>
										{new Date(row.dataEmbarque).toLocaleDateString("pt-BR", {
											month: "numeric",
											day: "numeric",
										})}
									</motion.td>
								);
							}
						}
					} else {
						if (col.tipo === "number") {
							let value;
							if (typeof row[col.field] === "string") {
								value = row[col.field].replace(",", ".");
							}
							if (isNaN(parseFloat(value))) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`col-${col.field}-${row[col.field]}-${row.id}`}
										style={{
											color: row.corCliente,
										}}
										className="td-right"
									>
										{row[col.field]}
									</motion.td>
								);
							} else {
								let floatValue = parseFloat(value);
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`col-${col.field}-${row[col.field]}`}
										style={{
											color: row.corCliente,
										}}
										className="td-right"
									>
										{floatValue.toLocaleString("pt-BR", {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</motion.td>
								);
							}
						} else {
							let value;
							if (typeof row[col.field] === "string") {
								value = row[col.field].replace(",", ".");
							}
							if (isNaN(parseFloat(value))) {
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`col-${col.field}-${row[col.field]}-${row.id}`}
										style={{
											color: row.corCliente,
										}}
									>
										{row[col.field]}
									</motion.td>
								);
							} else {
								let floatValue = parseFloat(value);
								return (
									<motion.td
										{...getMotionProps(index)}
										key={`col-${col.field}-${row[col.field]}-${row.id}`}
										style={{
											color: row.corCliente,
										}}
									>
										{floatValue.toLocaleString("pt-BR", {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</motion.td>
								);
							}
						}
					}
				} else {
					return <Fragment key={uuidv4()} />;
				}
			})}
		</>
	);
}

export default RenderBodyNomeTabelaDesordenada;
